const Testimonial = ({
  type,
  colorScheme,
  quote,
}) => {
  const authorQuote = quote.caption ? quote.caption : null
  const author = {
    name: quote?.author?.author,
    role: quote?.author?.role,
    image: quote?.author?.image ? {
      src: quote?.author?.image?.url,
      alt: quote?.author?.image?.alternativeText
    } : null
  }
  const image = quote.image ? {
    src: quote?.image?.url,
    alt: quote?.image?.alternativeText
  } : null
  const caption = quote.caption ? quote.caption : null

  const normalizedData = {
    variant: type === 'TestimonialsImage' ? 'image' : 'quote',
    colorScheme,
    quote: authorQuote,
    author,
    image,
    caption
  }

  return normalizedData
}

export default Testimonial